import SigninComponent from "@forwardflow/components/Signin";

const Signin = () => {
  return (
    <>
      <SigninComponent />
    </>
  );
};
export default Signin;
